import { ResourceType } from '../../../constants'
import { Resource } from '../../../types'

/**
 * Gets the first non-cabin resource from a list of resources.
 * This is used to avoid displaying cabin names in the UI, preferring to show
 * specialist/fitter names instead.
 *
 * @param resources - Array of resources to search through
 * @returns The first non-cabin resource, or undefined if none found
 */
const getSpecialistResource = (resources: Resource[] | undefined): Resource | undefined => {
  if (!resources) return

  return resources.find(({ type }) => type !== ResourceType.CABIN)
}

export { getSpecialistResource }
